//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "EventCard",
  props: ["data", "page"],
  data() {
    return {
      // data: [{}],
      isFavourite: false,
      hover: false,
      noTime: false,
      dateIconBlack: require("../../images/icon-date3-black.svg"),
      dateIconBlue: require("../../images/icon-date3-blue.svg"),
      timeIconBlack: require("../../images/icon-time-black.svg"),
      timeIconBlue: require("../../images/icon-time-blue.svg"),
      locationIconBlack: require("../../images/icon-location-pin-black.svg"),
      locationIconBlue: require("../../images/icon-location-pin-blue.svg"),
      beschikbaarLabel: require("../../images/tickets-available.png"),
      uitverkochtLabel: require("../../images/tickets-soldout.png")
    };
  },
  mounted() {
    this.checkFavourite();
  },
  computed: {
    dateIconHover() {
      if (this.hover) {
        return this.dateIconBlue;
      } else {
        return this.dateIconBlack;
      }
    },
    timeIconHover() {
      if (this.hover) {
        return this.timeIconBlue;
      } else {
        return this.timeIconBlack;
      }
    },
    locationIconHover() {
      if (this.hover) {
        return this.locationIconBlue;
      } else {
        return this.locationIconBlack;
      }
    }
  },
  methods: {
    checkFavourite() {
      // console.log('checiking sia');
      // console.log(this.isFavourite);
      const lstorage = JSON.parse(localStorage.getItem("eventFavourites"));
      if (lstorage !== undefined && lstorage !== null) {
        //check if event is in id
        const findPostId = lstorage.find(item => item === this.data.postid);
        if (findPostId !== undefined) {
          this.isFavourite = true;
        }
      } else {
        this.isFavourite = false;
      }
    },
    favourite() {
      // console.log('favourite clicked')
      const { postid } = this.data;
      const lstorage = JSON.parse(localStorage.getItem("eventFavourites"));
      if (lstorage !== undefined && lstorage !== null) {
        //check if event is in id
        const findPostId = lstorage.find(item => item === postid);
        if (findPostId === undefined) {
          //add it to the array,
          lstorage.push(postid);
          localStorage.setItem("eventFavourites", JSON.stringify(lstorage));
        } else {
          //remove from the array
          const index = lstorage.indexOf(findPostId);
          if (index > -1) {
            lstorage.splice(index, 1);
            localStorage.setItem("eventFavourites", JSON.stringify(lstorage));
            if (this.page === "favoriten") {
              this.$parent.unfavourite(findPostId);
            }
          }
        }
      } else {
        //add to localstorage
        localStorage.setItem(
          "eventFavourites",
          JSON.stringify([this.data.postid])
        );
      }
      this.isFavourite = !this.isFavourite;
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/EventCard.vue